// original-axios is a configed alias in build/webpack.base.conf.js
import axios from 'original-axios'
const cookies = require('cookies-js')
const LoginPathname = '/login'
/**
 * add authorization to header
 */
axios.interceptors.request.use(function (config) {
  const cookieAuth = cookies.get('PARTNER_TOKEN') || ''
  const headers = config.headers

  if (!headers.Authorization && cookieAuth) {
    headers['Authorization'] = cookieAuth
  }
  return config
})

/**
 * Authorization interceptions
 */
axios.interceptors.response.use(resp => resp, err => {
  if (err.response.status === 401 && window.location.pathname !== LoginPathname) {
    window.location.href = LoginPathname
  }
  return Promise.reject(err)
})

export default axios



// WEBPACK FOOTER //
// ./src/api/modified-axios.js